import { createAction } from 'typesafe-actions';
import { IPumpingStationMotorMake } from '../../../../@types/model/masterData/pumpingStation/motorMake';

export default class MasterDataPumpingStationMotorMakeActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPING_STATION_MOTOR_MAKES', resolve => (pumps : Array<IPumpingStationMotorMake>) => resolve(pumps));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPING_STATION_MOTOR_MAKES_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}